<template>
  <el-dialog
    :title="L10n('add-new-activity')"
    :visible="isVisible"
    custom-class="dialog-short-form"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose"
  >
    <el-form :model="form" v-loading="isLoading">
      <el-form-item
        :label="L10n('description')"
        props="description"
        class="material-style"
      >
        <el-input
          type="textarea"
          :value="form.description"
          @input="form.description = valueTrimLeft($event)"
        ></el-input>
      </el-form-item>
      <form-controls
        isCancel
        isCreate
        @command="handlerCommand"
      ></form-controls>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'ModalNew',
  components: {
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    },
    formModel: {
      type: Function,
      required: true
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler () {
        this.form = this.formModel()
      }
    }
  },
  data () {
    return {
      form: {}
    }
  },
  methods: {
    handleDialogClose () {
      this.$emit('update:isVisible', false)
    },
    handlerCommand (command) {
      if (command === 'cancel') {
        this.handleDialogClose()
      }
      if (command === 'save') {
        this.$emit('onCreate', { ...this.form })
      }
    }
  }
}
</script>
